import {
  Button,
  Datagrid,
  DeleteWithConfirmButton,
  EmailField,
  ExportButton,
  List,
  TextField,
  TopToolbar
} from 'react-admin'
import { useState } from 'react'
import { Box } from '@mui/material'
import InviteUser from './InviteUser'
import DatagridHeader from '../../../components/DatagridHeader'

import PersonAddIcon from '@mui/icons-material/PersonAdd'
import PersonRemoveIcon from '@mui/icons-material/PersonRemove'

const Actions = ({ onInviteClick }: { onInviteClick: () => void }) => (
  <TopToolbar>
    <Button
      label="Invite New User"
      startIcon={<PersonAddIcon />}
      onClick={onInviteClick}
      data-testid="invite-user-button"
    />
    <ExportButton />
  </TopToolbar>
)

const ManageUsers = () => {
  const [modalVisible, setModalVisible] = useState(false)

  const toggleModal = () => setModalVisible(!modalVisible)

  return (
    <Box>
      <List actions={<Actions onInviteClick={toggleModal} />}>
        <Datagrid
          header={<DatagridHeader hideColumns={['Remove']} />}
          bulkActionButtons={false}
        >
          <TextField source="User Name" />
          <EmailField source="User Email" />
          <DeleteWithConfirmButton
            label="Remove"
            confirmTitle="Remove User"
            confirmContent="Are you sure you want to remove this user?"
            icon={<PersonRemoveIcon />}
          />
        </Datagrid>
      </List>
      <InviteUser open={modalVisible} onClose={toggleModal} />
    </Box>
  )
}

export default ManageUsers
